export default {
  path: "/app/report-approval",
  redirect: "/app/report-approval/travel-requisition",
  component: () => import("../layout"),
  children: [
    {
      name: "travelRequisition",
      path: "/app/report-approval/travel-requisition",
      component: () => import("../travel-requisition.vue"),
      props: true,
      meta: {
        appName: "travelRequisition",
      },
    },
    {
      name: "stationeryRequest",
      path: "/app/report-approval/stationery-request",
      component: () => import("../stationery-request.vue"),
      props: true,
      meta: {
        appName: "stationeryRequest",
      },
    },
    {
      name: "creditApplication",
      path: "/app/report-approval/credit-application",
      component: () => import("../credit-application.vue"),
      props: true,
      meta: {
        appName: "creditApplication",
      },
    },
    {
      name: "partStocking",
      path: "/app/report-approval/part-stocking",
      component: () => import("../part-stocking.vue"),
      props: true,
      meta: {
        appName: "partStocking",
      },
    },
    {
      name: "borrowPart",
      path: "/app/report-approval/borrow-part",
      component: () => import("../borrow-part.vue"),
      props: true,
      meta: {
        appName: "borrowPart",
      },
    },
    {
      name: "partReturn",
      path: "/app/report-approval/part-return",
      component: () => import("../part-return.vue"),
      props: true,
      meta: {
        appName: "partReturn",
      },
    },
  ],
};
